import api from 'api';

export const types = {
  REQUEST: 'app/user/REQUEST',
  RECEIVE: 'app/user/RECEIVE_MAIN_USER',
  UPDATE: 'app/user/UPDATE_MAIN_USER',
  UPDATE_EMAIL: 'app/user/UPDATE_EMAIL',
  SET_PREFERRED_LANGUAGE: 'app/user/SET_PREFERRED_LANGUAGE',
  RECEIVE_GROUP_ROLES: 'app/user/RECEIVE_GROUP_ROLES',
};

function updateEmail(email) {
  return {
    type: types.UPDATE_EMAIL,
    payload: { email },
  };
}

function receive(userData) {
  return {
    type: types.RECEIVE,
    payload: userData,
  };
}

function request(userId) {
  return (dispatch) => {
    return api.userApi.get(userId).then((user) => {
      dispatch(receive(user));
    });
  }
}

function setPreferredLanguage({ id, language_code }, languageMessages) {
  return {
    type: types.SET_PREFERRED_LANGUAGE,
    payload: {
      languageCode: language_code,
      locale_id: id,
      languageMessages,
    },
  };
}

function updateUser(userData) {
  return _.assign({}, {
    type: types.UPDATE,
    payload: userData,
  });
}

function submitUserUpdate(userData) {
  return _.assign({}, {
    type: types.UPDATE,
    payload: userData,
  });
}

function receiveGroupRoles(userId, groupRoles) {
  const lookup = {};
  groupRoles.forEach(item => {
    lookup[item.group_id] = item;
  });

  return {
    type: types.RECEIVE_GROUP_ROLES,
    userId,
    payload: {
      lookup,
      collection: groupRoles.map(a => a.group_id),
    },
  };
}

function requestGroupRoles(userId) {
  return (dispatch) => {
    return api.userApi.getGroupRoles(userId).then((groupRoles) => {
      dispatch(receiveGroupRoles(userId, groupRoles));
    });
  }
}

const actions = {
  updateEmail,
  setPreferredLanguage,
  updateUser,
  submitUserUpdate,
  request,
  receive,
  requestGroupRoles,
};

export default actions;
